// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    color: #A9ADB9;
    justify-content: center;
    float: left;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    bottom: 0;
    padding: 5px;
    background-color: transparent;
    left: 0px;
    right: 0px;
    min-height: 40px;
    text-align: center;

    display: none;
}
.footer_collapse{
    color: #A9ADB9;
    justify-content: center;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    bottom: 0;
    left: 0px;
    right: 0px;
    padding: 5px;
    /* min-height: 40px; */
    float: left;
    width: 100%;
    background-color: transparent;
    text-align: center;

    display: none;
}


.footer_bottom{
    color: #A9ADB9;
    justify-content: center;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    bottom: 0;
    left: 0px;
    right: 0px;
    padding: 5px;
    /* min-height: 40px; */
    float: left;
    width: 100%;
    background-color: transparent;
    text-align: center;
    
}`, "",{"version":3,"sources":["webpack://./src/assets/css/footer.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,6BAA6B;IAC7B,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;;IAElB,aAAa;AACjB;AACA;IACI,cAAc;IACd,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;;IAElB,aAAa;AACjB;;;AAGA;IACI,cAAc;IACd,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;;AAEtB","sourcesContent":[".footer {\n    color: #A9ADB9;\n    justify-content: center;\n    float: left;\n    width: 100%;\n    font-size: 14px;\n    font-weight: 500;\n    bottom: 0;\n    padding: 5px;\n    background-color: transparent;\n    left: 0px;\n    right: 0px;\n    min-height: 40px;\n    text-align: center;\n\n    display: none;\n}\n.footer_collapse{\n    color: #A9ADB9;\n    justify-content: center;\n    width: 100%;\n    font-size: 14px;\n    font-weight: 500;\n    bottom: 0;\n    left: 0px;\n    right: 0px;\n    padding: 5px;\n    /* min-height: 40px; */\n    float: left;\n    width: 100%;\n    background-color: transparent;\n    text-align: center;\n\n    display: none;\n}\n\n\n.footer_bottom{\n    color: #A9ADB9;\n    justify-content: center;\n    width: 100%;\n    font-size: 14px;\n    font-weight: 500;\n    bottom: 0;\n    left: 0px;\n    right: 0px;\n    padding: 5px;\n    /* min-height: 40px; */\n    float: left;\n    width: 100%;\n    background-color: transparent;\n    text-align: center;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
